import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { TextcontentModel } from './textcontent.model';
import { ResourceModel } from './resource.model';

export class TexttemplateModel extends BaseModel implements Deserializable {

  // columns
  identifier: string;
  type: string; // @todo ENUM
  context: string;
  description: string = null;
  placeholders: any = null;
  misc: any = null;
  migrated: boolean;

  // relations
  contents: Array<TextcontentModel> = [];
  files: Array<ResourceModel> = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    // contents
    const contents = [];
    if (this.contents !== null && this.contents !== undefined) {
      this.contents.forEach((content: TextcontentModel) => {
        contents.push(new TextcontentModel().deserialize(content));
      });
    }
    this.contents = contents;
    // files
    const files = [];
    if (this.files !== null && this.files !== undefined) {
      this.files.forEach((file: ResourceModel) => {
        files.push(new ResourceModel().deserialize(file));
      });
    }
    this.files = files;
    return this;
  }

  public get language_list(): string {
    return this.contents.map((content: TextcontentModel) => {
      return content?.language?.key;
    }).join(' | ');
  }

}
